export default __webpack_public_path__ + "static/media/clinique.1892999a.png";